// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  ASSIGN_PATH_DATA,
  PATH_DETAILS_ERROR,
  TOGGLE_PASSIVE_REPEATER_DISPLAY,
  UPDATE_PASSIVE_REPEATER_STORE,
} from './types'

export const assignPathData = (pathInfo, comments) => ({
  type: ASSIGN_PATH_DATA,
  pathInfo,
  comments,
})

export const pathDetailsError = error => ({
  type: PATH_DETAILS_ERROR,
  error,
})

export const togglePassiveRepeaterDisplay = () => ({
  type: TOGGLE_PASSIVE_REPEATER_DISPLAY,
})

export const updatePassiveRepeaterStore = p => ({
  type: UPDATE_PASSIVE_REPEATER_STORE,
  p,
})
